<script setup>
defineProps({
  message: {
    type: String,
    default: 'Saved!',
  },
})
</script>

<template>
  <div
    class="flex items-center rounded-full bg-[#F9FAFB] px-4 py-2.5 text-sm font-semibold text-black shadow-sm absolute lg:left-[105%] lg:bottom-[0%] w-max bottom-[-15%] left-[30%]"
  >
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    {{ message }}
  </div>
</template>
<style scoped></style>
